//  作业的首页
<template>
  <div id="" class="mainDiv">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
      <el-tab-pane
        label="老师端"
        name="teacher"
        v-if="this.isTeacher == true || this.isAdmin == true"
      >
        <homework-teacher
          :course-id="courseId"
          :course-type="courseType"
        ></homework-teacher>
      </el-tab-pane>
      <el-tab-pane
        label="学生端"
        name="student"
        v-if="this.isStudent == true || this.isAdmin == true"
      >
        <homework-student
          :course-id="courseId"
          :course-type="courseType"
        ></homework-student>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { confirmMsg } from "@/utils/common";
import * as api from "@/api/homework/homework";
import HomeworkTeacher from "./homework-teacher";
import homeworkStudent from "./homework-student";
export default {
  name: "homeworkAdmin",
  components: {
    HomeworkTeacher,
    homeworkStudent,
  },
  data() {
    return {
      loading: false,
      activeTab: "teacher",
      courseId: this.$route.query.courseId || "107",
      courseType: this.$route.query.courseType || "zy_video",
      isTeacher: false,
      isStudent: false,
      isAdmin: false,
    };
  },
  methods: {
    getdata() {
      // const { courseId, courseType, createUserid }=this.query
      console.log();
      let reqdata = {
        uid: localStorage.getItem("uid") || "36",
      };
      api.getRole(reqdata).then((res) => {
        //状态转换
        console.log(res.data.msg);
        if (res.data.msg == "1") {
          this.isTeacher = true;
          this.isStudent = true;
          this.activeTab = "teacher";
          this.isAdmin = true;
        } else if (res.data.msg == "2") {
          this.isTeacher = false;
          this.isStudent = true;
          this.activeTab = "student";
          this.isAdmin = false;
        } else {
          this.isTeacher = true;
          this.isStudent = false;
          this.activeTab = "teacher";
          this.isAdmin = false;
        }
      });
    },
    // tab切换
    handleClick() {
      // this.pageObj.page = 1
      // this.getList()
    },
    goBack() {
      window.history.go(-1);
    },
  },
  mounted() {
    this.getdata();
  },
  created() {},
  computed: {
    getUId() {
      return localStorage.getItem("uid") || "36";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs--top {
  font-size: 12px;
}
</style>
